export interface ServicePackage {
  id: 'launch' | 'pilot'
  name: string
  badge?: string
  monthly: string
  onboardingStandard: string
  onboardingOffer: string
  totalDueToStart: string
  featuresHeading: string
  features: string[]
  featured: boolean
}

export const packages: ServicePackage[] = [
  {
    id: 'launch',
    name: 'Launch',
    monthly: '$315',
    onboardingStandard: '$997',
    onboardingOffer: '$499',
    totalDueToStart: '$814',
    featuresHeading: 'What you get',
    features: [
      'Mobile-responsive website',
      'Online booking / scheduler',
      'CRM — your own 1Dash.Pro account',
      'Contact forms & lead capture',
    ],
    featured: false,
  },
  {
    id: 'pilot',
    name: 'Pilot',
    badge: 'Best Value',
    monthly: '$615',
    onboardingStandard: '$997',
    onboardingOffer: '$499',
    totalDueToStart: '$1,114',
    featuresHeading: 'Everything in Launch, plus',
    features: [
      'AI phone attendant answering 24/7',
      'Review automation',
      'Full CRM with pipelines & automation',
      '1 business phone number',
    ],
    featured: true,
  },
]
